module.exports = __webpack_public_path__ + "static/media/intro-image-1.1298e049.jpg";